import React from 'react';
import {
  Affix, Layout, Row, Col,
} from 'antd';
import FA from 'react-fontawesome';
// eslint-disable-next-line import/no-extraneous-dependencies
import { globalHistory } from '@reach/router';
import style from './sidebar.module.less';
import { useWindowSize } from '../../../utils/hooks';
import Config from '../../../../config';

const { Content } = Layout;
const {
  github, linkedin,
} = Config.social;
const {
  django, lammps, gromacs, python, dash, docker, gatsby, react
} = Config.skills;

const DomContent = () => (
  <aside>
    <div className={style.profileAvatar} />
    <div className={`${style.name} centerAlign`}>
      <div className={`${style.boxName} centerAlign`}>
        <h2>
          <span>Tech office</span>
          {' '}
          <span>Mori</span>
        </h2>
      </div>
      <div className={`${style.badge} ${style.badgeGray}`}>Material & Software Engineer</div>
      <div className="centerAlign box">
        <a href={github} target="_blank" label="button" rel="noopener noreferrer"><FA name="github"/></a>
        <a href={linkedin} target="_blank" label="button" rel="noopener noreferrer"><FA name="linkedin" /></a>
      </div>
      <div className={`${style.skillsname} centerAlign`}>
        <h2>
          <span>Skills</span>
        </h2>
      </div>
      <div className={`${style.skills} centerAlign box`}>
        <a href={react} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://raw.githubusercontent.com/reactjs/reactjs.org/main/src/icons/logo.svg" alt="react-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={gatsby} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://www.gatsbyjs.com/Gatsby-Monogram.svg" alt="gatsby-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={django} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://static.djangoproject.com/img/logos/django-logo-positive.svg" alt="django-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={dash} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://raw.githubusercontent.com/plotly/dash/5c2f05e7a557716f0bfe2633e394fca1c6342ea9/components/dash-core-components/tests/integration/upload/upload-assets/upft001.svg" alt="dash-logo" height="30" hspace="10" vspace="10"></img>
        </a>
        <a href={lammps} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://raw.githubusercontent.com/lammps/lammps/stable/doc/utils/sphinx-config/_static/lammps-logo.png" alt="lammps-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={gromacs} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://raw.githubusercontent.com/gromacs/gromacs/bd791c7cba317d8d59c86c2edcc923d6263f8d0a/docs/reference-manual/plots/GMX_logos/gmx_logo_black.svg" alt="gromacs-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={python} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://www.python.org/static/community_logos/python-logo-generic.svg" alt="python-logo" height="25" hspace="10" vspace="10"></img>
        </a>
        <a href={docker} target="_blank" label="button" rel="noopener noreferrer">
          <img src="https://www.docker.com/wp-content/uploads/2022/03/horizontal-logo-monochromatic-white.png" alt="docker-logo" height="25" hspace="10" vspace="10"></img>
        </a>
      </div>
    </div>
  </aside>
);
const Sidebar = (props) => {
  const [width] = useWindowSize();
  const { children } = props;
  const { pathname } = globalHistory.location;
  let domContent = <DomContent />;
  if (width > 997) {
    domContent = (
      <Affix offsetTop={0}>
        <DomContent />
      </Affix>
    );
  }
  if (width < 768) {
    domContent = <></>;
    if (pathname === '/') {
      domContent = <DomContent />;
    }
  }
  return (
    <>
      <Layout>
        <Content className={`${style.content} ${style.background}`}>
          <Row>
            <Col sm={24} md={9} lg={6} className={style.sidebarContent}>
              { domContent }
            </Col>
            <Col sm={24} md={15} lg={18}>
              <Layout className={`${style.background} ${style.boxContent} borderRadiusSection`}>
                { children }
              </Layout>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export const Sidebar404 = (props) => {
  const { children } = props;
  return (
    <Layout>
      <Content className={`${style.content} ${style.background} `}>
        <Row>
          <Col sm={24} md={24} lg={24}>
            <Layout className={`${style.background} ${style.boxContent} ${style.sideBar404Radius}`}>
              {children}
            </Layout>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Sidebar;
